/**
 * Contrats d'intégration matérielle (lecteurs d'empreintes, tablette de signature,
 * capture photo). Voir docs/hardware-integration.md pour le détail des protocoles
 * réels (DigitalPersona, SecuGen, Wacom STU, Evolis Sig100/signotec) et des
 * ports locaux utilisés.
 *
 * Ces types sont partagés afin que le front (implémentation réelle des pilotes)
 * et l'API (validation des payloads de capture reçus) restent en phase.
 */
export const FINGERPRINT_DRIVERS = ['DIGITAL_PERSONA', 'SECUGEN', 'MOCK'];
export const SIGNATURE_DRIVERS = ['WACOM_STU', 'SIGNOTEC_SIG100', 'CANVAS', 'MOCK'];
export const FACE_CAPTURE_DRIVERS = ['WEBCAM', 'MOCK'];
export const DEFAULT_STATION_HARDWARE_CONFIG = {
    fingerprintDriver: 'MOCK',
    signatureDriver: 'MOCK',
    faceCaptureDriver: 'MOCK',
};
//# sourceMappingURL=devices.js.map